import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'
import { QuestionMarkCircleIcon } from '@heroicons/react/outline'

const ToolTip = ({ text }) => {
    return (
        text && (
            <div className="relative flex flex-col items-center justify-center group">
                <QuestionMarkCircleIcon className="text-black30 stroke-current stroke-2 w-4 h-4" />
                <div className="absolute top-0 flex flex-col items-center hidden mt-6 group-hover:flex">
                    <div className="w-3 h-3 transform rotate-45 bg-black50"></div>
                    <span className="relative inline-block -mt-2 w-54 z-10 p-2 leading-none text-white font-normal whitespace-normal bg-black50 shadow-lg rounded-lg text-center text-xs">
                        {text}
                    </span>
                </div>
            </div>
        )
    )
}

ToolTip.propTypes = {
    text: PropTypes.string,
}

const InfoLine = ({
    label,
    value,
    link,
    longLabel = false,
    prompText = '',
    extraLineClass = '',
}) => {
    return (
        <div
            className={clsx(
                'w-full flex lg:flex-row flex-col lg:items-center items-start gap-y-1 justify-start',
            )}
        >
            <div
                className={clsx(
                    'text-left w-full text-textDarkerGray font-medium text-sm',
                    longLabel ? 'lg:w-1/2' : 'lg:w-1/4',
                    extraLineClass,
                )}
            >
                <div className="flex gap-2">
                    {label}
                    <ToolTip text={prompText} />
                </div>
            </div>
            <div
                className={clsx(
                    'text-left w-full flex-grow text-black70 font-normal text-base',
                    extraLineClass,
                )}
            >
                {value}
            </div>
            {link && link}
        </div>
    )
}

InfoLine.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.any,
        PropTypes.element,
    ]),
    link: PropTypes.oneOfType([PropTypes.element, PropTypes.any]),
    longLabel: PropTypes.bool,
    prompText: PropTypes.string,
    extraLineClass: PropTypes.string,
}

export default InfoLine
